import {ActionTree} from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';
import EntryLink from "../ts/EntryLink";

export const actions: ActionTree<any, any> = {

    getEntryLinks: ({state, getters, commit, dispatch}, force) => {

        if (force) commit('clearCache');

        return new Promise((resolve, reject) => {

            // Pull from store if loaded and cache hasn't expired
            if (state.expires && moment().isBefore(state.expires)) {
                resolve(state.links);
            } else {

                commit('setLoading', true);

                axios.get('/entry-links')

                    .then((response: AxiosResponse) => {
                        commit('setData', response.data.data);
                        commit('setLoading', false);
                        resolve(response.data.data);
                    })
                    .catch((error: AxiosError) => {
                        commit('setLoading', false);
                        reject(error.response);
                    });
            }
        });
    },

    saveEntryLink: ({state, getters, commit, dispatch}, data) => {

        commit('setSaving', true);

        return new Promise((resolve, reject) => {

            axios.post('/entry-links', data)

                .then((response: AxiosResponse) => {
                    commit('appendLink', response.data.created);
                    commit('setSaving', false);
                    resolve(null);
                })
                .catch((error: AxiosError) => {
                    commit('setSaving', false);
                    reject(error);
                });
        });
    },

    updateEntryLink: ({state, getters, commit, dispatch}, data) => {

        commit('setSaving', true);

        return new Promise((resolve, reject) => {

            axios.put('/entry-links/'+data.id, data)

                .then((response: AxiosResponse) => {
                    commit('updateLink', response.data.updated);
                    commit('setSaving', false);
                    resolve(null);
                })
                .catch((error: AxiosError) => {
                    commit('setSaving', false);
                    reject(error.response);
                });
        });
    },

    deleteEntryLink: ({state, getters, commit, dispatch}, id) => {

        const backup = state.entryLinks.find((entryLink: EntryLink) => entryLink.id === id);

        return new Promise((resolve, reject) => {

            commit('deleteLink', id);

            axios.delete('/entry-links/'+id)

                .then((response: AxiosResponse) => {
                    resolve(null);
                })
                .catch((error: AxiosError) => {
                    commit('appendLink', backup);
                    reject(error.response);
                });
        });
    },
};
